import { Card } from 'antd'
import styled from 'styled-components'

const ReasonCard = styled(Card)`
  height: 100%;
`

export { ReasonCard }
